import { useApp } from "../state/AppState";

/**
 * Le rappel d'un achat en cours, à l'entrée du site.
 *
 * Le navigateur retenait bien la transaction — mais le seul bouton qui menait
 * au rapport payé vivait sur l'écran de résultat. Un acheteur qui revenait plus
 * tard devait donc **refaire un diagnostic entier**, saisie et trente secondes
 * d'analyse comprises, avant d'apercevoir une porte vers ce qu'il avait déjà
 * payé. La mémoire existait, elle était simplement inatteignable.
 *
 * Ce bandeau est la première chose que voit celui qui revient, et la dernière
 * chose que voit celui qui n'a rien acheté : sans transaction en mémoire, il
 * ne s'affiche pas du tout.
 */
export function RappelAchat() {
  const { achat, openPay, oublierLAchat } = useApp();
  if (achat === null) return null;

  const jours = Math.floor((Date.now() - achat.quand) / (24 * 60 * 60 * 1000));
  const quand =
    jours === 0 ? "aujourd'hui" : jours === 1 ? "hier" : `il y a ${jours} jours`;

  return (
    <div className="rappel-achat">
      <div className="shell">
        <p>
          <b>Vous avez un rapport en attente.</b> Paiement engagé {quand} depuis cet appareil. Vous
          n'avez pas besoin de refaire le diagnostic pour le récupérer.
        </p>
        <button type="button" className="btn btn-brass" onClick={() => openPay(achat.plan)}>
          Récupérer mon rapport
        </button>
        {/*
          La sortie. Elle manquait, et son absence a piégé le premier acheteur
          réel : sa rédaction avait échoué, le rapport était donc irrécupérable,
          et ce bandeau lui redemandait indéfiniment de récupérer ce qui
          n'existait pas — sans aucun moyen de le faire disparaître. Un rappel
          qu'on ne peut pas fermer n'est plus un service rendu, c'est un
          obstacle.

          Ce que le bouton fait est dit sans détour : il oublie la trace locale.
          La transaction, elle, continue d'exister côté serveur — c'est elle qui
          fonde le remboursement, et elle ne dépend pas de ce navigateur.
        */}
        <button
          type="button"
          className="rappel-masquer"
          onClick={oublierLAchat}
          title="Ce rappel disparaît de cet appareil. Votre paiement reste enregistré chez nous."
        >
          Masquer ce rappel
        </button>
      </div>
    </div>
  );
}
